import { SELECIONAR_VEICULO_ITINERARIO, LIMPAR_VEICULO_ITINERARIO_SELECIONADO } from '../../actions/types'

const initialState = null
const estadoInicialVeiculoItinerario = {
  label: '',
  value: {}
}

export default function reducerVeiculoItinerarioSelecionado (state = estadoInicialVeiculoItinerario, action = initialState) {
  switch (action.type) {
    case SELECIONAR_VEICULO_ITINERARIO: {

      if (action.payload) {
        return action.payload;
      }      

      return state
    }

    case LIMPAR_VEICULO_ITINERARIO_SELECIONADO: {
      return estadoInicialVeiculoItinerario;
    }

    default: {
      return state
    }
  }
}
